/***
 *
 *   LOGO
 *   Replace the image in /images with your own logo
 *
 **********/

import { Link } from 'components/lib';
import LogoDark from './images/logo-dark.png';
import LogoMarkDark from './images/logo-mark-dark.png';

interface LogoProps {
  mark?: boolean;
  linked?: boolean;
  className?: string;
  [key: string]: unknown;
}

export function Logo(props: LogoProps) {
  const isMark = props.mark === true;
  const dimensions = isMark ? { width: 47, height: 34, src: LogoMarkDark } : { width: 200, height: 63, src: LogoDark };

  const image = (
    <img
      src={dimensions.src}
      alt="Logo"
      width={dimensions.width}
      height={dimensions.height}
      loading="eager"
      decoding="async"
      style={{
        width: `${dimensions.width}px`,
        height: `${dimensions.height}px`,
        display: 'block',
      }}
    />
  );

  if (props.linked === false) return image;

  return (
    <Link url="/dashboard" className={`left-value-10 top-value-16 ${props.className ?? ''}`.trim()}>
      {image}
    </Link>
  );
}
